import { ProductsFbtCollectionModel, fbtUploadFile } from "@NA/Services/ADIFbtUploadService";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { HasOnError, HasOnSuccess, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

type HandlerType = CustomApiHandler<ProductsFbtCollectionModel[] & HasOnSuccess & HasOnError, ServiceResult<boolean>>;

export const DispatchBeginLoadFbtUpload: HandlerType = props => {
    props.dispatch({
        type: "Custom/BeginLoadFbtUpload",
        parameter: props.parameter,
    });
};
export const PopulateApiParameter: HandlerType = (props: any) => {
    props.apiParameter = { ...props.parameter };
};
export const LoadFbtUpload: HandlerType = async props => {
    props.apiResult = await fbtUploadFile(props.apiParameter);
};

export const DispatchCompleteLoadFbtUpload: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult as any);
    props.dispatch({
        type: "Custom/CompleteLoadFbtUpload",
        result: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [DispatchBeginLoadFbtUpload, PopulateApiParameter, LoadFbtUpload, DispatchCompleteLoadFbtUpload];

const fbtUpload = createHandlerChainRunner(chain, "FbtUpload");
export default fbtUpload;
